export default function _dev() {
  return [
    'textGeneral',
    'textBlob',
    'textSwapper',
    'header',
    'grid',
    'columns',
    'googleMap',
    'navigation',
    'button',
    'socialMedia',
    'form',
    'accordion',
    'modal',
    'cardsTall',
    'cardsGeneral',
    'cardsWide',
    'cardsEvent',
    'cardsStep',
    'imageGallery',
    'imageGeneral',
    'table',
    'tabs',
    'audioPlayer',
    'carousel',
    'codeGeneral',
    'contentSlider',
    'countdown',
    'divider',
    'copyright',
    'footerNav',
    'videoPlayer',
    'youTubeVideo',
    'progressBar',
    'audioSeries',
    'videoSeries',
    'serviceCountdown',
    'menuGrid',
    'pdfMenu',
    'listMenu',
    'buyButton',
    'blogPost',
    'blogList',
    'blogFeed',
    'blogGrid',
    'productFeature',
    'productCard',
    'productFeed',
    'productGrid',
    'projectCards',
    'projectFeed',
    'projectGrid',
    'projectDetails',
    'profileCards',
    'profileGrid',
    'profileDetails',
    'profileFeed',
    'placeDetails',
    'placeGrid',
    'placeCards',
    'placeFeed',
    'mediaItem',
    'mediaItemFeed',
    'mediaItemGrid',
    'mediaItemList',
    'groupGrid',
    'groupItem',
    'groupList',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/_dev.js